import React from 'react';
import { Box } from '@hub/box';
import { ColorCard, ColorCards } from '../color-cards';
import { ColorCardSlim } from '../color-cards-slim';
import { ColorCardWithoutImage } from '../color-cards-without-image';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductListHeader = _ref => {
  var _banner$heroImageSet, _banner$heroImageSet$, _banner$heroImageSet2;

  let {
    layout,
    banner,
    termsAndConditionsLink
  } = _ref;
  const heroImageUrl = banner === null || banner === void 0 ? void 0 : (_banner$heroImageSet = banner.heroImageSet) === null || _banner$heroImageSet === void 0 ? void 0 : _banner$heroImageSet.master.url;
  const supportingColour = (_banner$heroImageSet$ = banner === null || banner === void 0 ? void 0 : (_banner$heroImageSet2 = banner.heroImageSet) === null || _banner$heroImageSet2 === void 0 ? void 0 : _banner$heroImageSet2.masterSupportingColour) !== null && _banner$heroImageSet$ !== void 0 ? _banner$heroImageSet$ : 'smoke';
  const heroImageExist = (banner === null || banner === void 0 ? void 0 : banner.heroImageSet) && heroImageUrl;

  if (!layout && !heroImageExist) {
    return null;
  }

  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      marginBottom: 'spacing-lg',
      width: !heroImageExist && [null, null, null, '80%']
    },
    "data-id": "product-list-header_index_ProductListHeader_Box",
    children: [!layout && heroImageExist && /*#__PURE__*/_jsx(ColorCards, {
      hasOuterMargins: false,
      "data-id": "product-list-header_index_ProductListHeader_ColorCards",
      children: /*#__PURE__*/_jsx(ColorCard, {
        isFullWidth: true,
        sx: {
          '& .chakra-aspect-ratio': {
            // it doesn't work to just set width
            maxWidth: [null, null, 'size-2xl'],
            minWidth: [null, null, 'size-2xl']
          }
        },
        title: banner.title,
        shortDescription: banner.bodyCopy,
        image: {
          type: 'SQUARE',
          url: heroImageUrl,
          supportingColour
        },
        "data-id": "product-list-header_index_ProductListHeader_ColorCards_ColorCard"
      })
    }), layout === 'slim' && /*#__PURE__*/_jsx(_Fragment, {
      children: heroImageExist ? /*#__PURE__*/_jsx(ColorCardSlim, {
        banner: banner,
        termsAndConditionsLink: termsAndConditionsLink,
        "data-id": "product-list-header_index_ProductListHeader_ColorCardSlim"
      }) : /*#__PURE__*/_jsx(ColorCardWithoutImage, {
        banner: banner,
        termsAndConditionsLink: termsAndConditionsLink,
        "data-id": "product-list-header_index_ProductListHeader_ColorCardWithoutImage"
      })
    })]
  });
};